import React from 'react';
import i18n from '../../i18n';
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import {withStyles} from "@material-ui/core/styles";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";
import Date from "../Formater/Date";

class ArchiveGrid extends React.Component {
    render() {
        const {appointments, classes} = this.props;

        return (
            <section>
                <Grid container spacing={16}>
                    {appointments.map(appointment => {

                        return (
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={appointment.id}>
                                <Card>
                                    <a href={`/appointments/${appointment.id}`} style={{textDecoration: 'none'}}>
                                        <CardContent className={classes.cardContent}>
                                            <Grid container spacing={8} justify="space-between" alignItems="center">
                                                <Grid item xs={12}>
                                                    <Typography variant="h6" component="h2">
                                                        <EllipisWithTooltip>{appointment.appointment_name}</EllipisWithTooltip>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container spacing={8} justify="space-between"
                                                          alignItems="center">
                                                        <Grid item xs={6}>
                                                            <Typography>
                                                                {i18n.get('appointments.project_number')}:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Typography>
                                                                {appointment.project_number}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container spacing={8} justify="space-between"
                                                          alignItems="center">
                                                        <Grid item xs={6}>
                                                            <Typography>
                                                                {i18n.get('appointments.day_last_appointment_short')}:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Typography>
                                                                <Date value={appointment.day_last_appointment}/>
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container spacing={8} justify="space-between"
                                                          alignItems="center">
                                                        <Grid item xs={6}>
                                                            <Typography>
                                                                {i18n.get('appointments.machine')}:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Typography>
                                                                {appointment.machine.name}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container spacing={8} justify="space-between"
                                                          alignItems="center">
                                                        <Grid item xs={6}>
                                                            <Typography>
                                                                {i18n.get('appointments.technician')}:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Typography>
                                                                {appointment.technician.name}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </a>
                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>
            </section>
        )
    }
}

const styles = theme => ({
    cardContent: {
        minHeight: '150px'
    },
    cardActions: {
        padding: '4px 8px',
    },
    chip: {
        height: '24px',
    },
    chipLabel: {
        padding: '0 8px'
    },
    iconButton: {
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1
        }
    },
    iconButtonIcon: {
        fontSize: 20
    },
    popper: {
        fontSize: 14,
        boxShadow: '2px 2px 3px rgba(0,0,0,0.3)'
    }
});

export default withStyles(styles)(ArchiveGrid);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Archives/ArchiveGrid.js